import {
  useDocumentEditorVariations,
  useDocumentEditorVariationsBoundaries,
} from 'src/services/document';
import { useActiveVariationInstanceId } from '../../../services';

export const useDocumentVariationsData = (parentElement) => {
  const activeInstanceId = useActiveVariationInstanceId();

  const variations = useDocumentEditorVariations(null, true);
  const boundaries = useDocumentEditorVariationsBoundaries({ parentElement, activeInstanceId });

  return {
    variations,
    boundaries,
  };
};
